import {
    instance
} from '../../util/http'
import apis from '../../config/apis'


// 分享人列表 店长 月分享
const list = (type, month, page, limit) => {
    return instance.get(apis.MyShare.List + "?ServicePersonListType=" + type + "&Month=" + month + "&Page=" + page + "&PageSize=" + limit);
}
// 切换账号 分享人列表
const switchAccounServicePersonList = (type, month, page, limit,UserId) => {
    return instance.get(apis.MyShare.switchAccounServicePersonList + "?ServicePersonListType=" + type + "&Month=" + month + "&Page=" + page + "&PageSize=" + limit+ "&UserId=" + UserId);
}
//  分享人列表 店员
const servicePersonForEmployeeList = (type, month, page, limit) => {
    return instance.get(apis.MyShare.ServicePersonForEmployeeList + "?ServicePersonListType=" + type + "&Month=" + month + "&Page=" + page + "&PageSize=" + limit);
}
// 切换账号 分享人列表 店员
const switchAccounForEmployeeList = (type, month, page, limit,UserId) => {
    return instance.get(apis.MyShare.switchAccounForEmployeeList + "?ServicePersonListType=" + type + "&Month=" + month + "&Page=" + page + "&PageSize=" + limit+ "&UserId=" + UserId);
}
// 下单商品详情
const detail = (id, page, limit) => {
    return instance.get(apis.MyShare.Detail + "?UserId=" + id + "&Page=" + page + "&PageSize=" + limit)
}
// 获取年月 店长
const GetDate = () => {
    return instance.get(apis.MyShare.GetDate)
}
// 获取年月 店员
const dateForEmployee = () => {
    return instance.get(apis.MyShare.DateForEmployee)
}
// 维护会员 body string类型
const post = (data) => {
    return instance.post(apis.MyShare.Post, '"' + data + '"', {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

// 客情维护
const customerList = (page,limit) => {
    return instance.get(apis.MyShare.customerList + "?Page=" + page + "&PageSize=" + limit)
}
// 我的统计 代买人列表
const statisticsList = (page,limit) => {
    return instance.get(apis.MyShare.statisticsList + "?Page=" + page + "&PageSize=" + limit)
}


// 我的统计 代买人下单详情
const agentDetail = (name, page,limit) => {
    return instance.get(apis.MyShare.agentDetail + "?AgentName=" + name + "&Page=" + page + "&PageSize=" + limit)
}

// 我的统计 获取用户关注
const followList = (page,limit) => {
    return instance.get(apis.Follow.List + "?page=" + page + "&pageSize=" + limit)
}
// 我的统计 获取用户关注分页
const followPageList = (page,limit) => {
    return instance.get(apis.Follow.followPageList + "?page=" + page + "&pageSize=" + limit)
}
// 获取用户切换账号列表
const accountList = () => {
    return instance.get(apis.MyShare.AccountList)
}
// 获取是否有子账号，是否显示按钮
const isShowSwitch = () => {
    return instance.get(apis.MyShare.isShowSwitch)
}
export default {
    list,
    detail,
    GetDate,
    post,
    customerList,
    statisticsList,
    agentDetail,
    dateForEmployee,
    servicePersonForEmployeeList,
    followList,
    followPageList,
    accountList,
    switchAccounServicePersonList,
    switchAccounForEmployeeList,
    isShowSwitch
}